import React, { Component, Fragment } from 'react';
import { Field } from 'redux-form';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import {
  CRITERIA_OPTIONS,
  CRITERIA_TYPES,
  CRITERIA_TAG_TYPES,
  CRITERIA_TAG_OPTIONS,
  CRITERIA_OPERATION_TYPES,
  CRITERIA_TAG_PROPERTY_OPTIONS,
  CRITERIA_TAG_PROPERTY_COMPARE_OPTIONS
} from '../../../../constants/triggers';
import styles from './AddCriteriaForm.styles';

import Button from '../../../inputs/button/Button';
import CriteriaCard from '../../../data/criteriacard/CriteriaCard';
import FormField from '../../formfield/FormField';

const loadOption = option => ({
  label: I18n.t(option.label),
  value: option.value
});

export class AddCriteriaForm extends Component {
  listToOptions = list =>
    list
      ? list.map(item => ({
          value: item,
          label: item.name
        }))
      : [];
  renderPropertyValues = (prop, compareBy, criteriaName) => {
    if (CRITERIA_TAG_PROPERTY_OPTIONS[compareBy].showValues) {
      let list = [];
      switch (prop) {
        case CRITERIA_TAG_TYPES.SITE: {
          list = this.props.sites;
          break;
        }
        case CRITERIA_TAG_TYPES.AREA: {
          list = this.props.areas;
          break;
        }
        case CRITERIA_TAG_TYPES.ZONE: {
          list = this.props.zones;
          break;
        }
        case CRITERIA_TAG_TYPES.LOCATION: {
          list = this.props.locations;
          break;
        }
        case CRITERIA_TAG_TYPES.CATEGORY: {
          list = this.props.categories;
          break;
        }
        case CRITERIA_TAG_TYPES.GROUP: {
          list = this.props.groups;
          break;
        }
        default:
          break;
      }
      return (
        <Field
          name={criteriaName + 'compareTo'}
          type="select"
          placeholder={I18n.t('add.criteria.select', {
            property: I18n.t(CRITERIA_TAG_OPTIONS[prop].label)
          })}
          component={FormField}
          options={this.listToOptions(list)}
          styles={styles.criteriaField}
        />
      );
    }
    return;
  };

  render() {
    const { fields, meta, criteria, change } = this.props;
    const isEditing = criteria && criteria.find(crit => crit.isEditing);
    const typeOptions = Object.values(CRITERIA_OPTIONS).map(loadOption);
    const tagPropertyOptions = Object.values(CRITERIA_TAG_OPTIONS).map(
      loadOption
    );
    if (fields && fields.length === 0) {
      fields.push({ isEditing: true, operation: CRITERIA_OPERATION_TYPES.AND });
    }
    return (
      <div className={css(styles.criteriaList)}>
        <div className={css(styles.label, styles.criteriaTitle)}>
          <Translate value="models.trigger.criteria" />:
        </div>
        {fields &&
          fields.map(
            (criteriaName, index) =>
              criteria && criteria[index].isEditing ? (
                <div key={index} className={css(styles.criteria)}>
                  <Field
                    styles={[styles.criteriaType, styles.criteriaField]}
                    name={criteriaName + 'type'}
                    type="custom-radio"
                    component={FormField}
                    options={typeOptions}
                  />
                  {criteria &&
                    criteria[index] &&
                    criteria[index].type === CRITERIA_TYPES.TAG_PROPERTY && (
                      <Fragment>
                        <span className={css(styles.label)}>
                          <Translate value="models.criteria.type.tagProperty" />:
                        </span>
                        <Field
                          name={criteriaName + 'property'}
                          type="select"
                          placeholder={I18n.t('add.triggers.tagProperty')}
                          component={FormField}
                          options={tagPropertyOptions}
                          styles={styles.criteriaField}
                          normalize={(value, prevValue) => {
                            if (value !== prevValue) {
                              change(criteriaName + 'compareBy', null);
                              change(criteriaName + 'compareTo', null);
                            }
                            return value;
                          }}
                        />
                      </Fragment>
                    )}
                  {criteria &&
                    criteria[index] &&
                    criteria[index].property &&
                    CRITERIA_TAG_PROPERTY_COMPARE_OPTIONS[
                      criteria[index].property
                    ].map((compareBy, compareIndex) => (
                      <Fragment key={compareIndex}>
                        <Field
                          name={criteriaName + 'compareBy'}
                          type="radio"
                          component={FormField}
                          value={compareBy.value}
                          text={I18n.t(compareBy.label)}
                          fullWidth={true}
                          styles={styles.criteriaProperty}
                          normalize={(value, prevValue) => {
                            if (value !== prevValue) {
                              change(criteriaName + 'compareTo', null);
                            }
                            return value;
                          }}
                        />
                        {criteria[index] &&
                          criteria[index].compareBy === compareBy.value &&
                          this.renderPropertyValues(
                            criteria[index].property,
                            compareBy.value,
                            criteriaName
                          )}
                      </Fragment>
                    ))}
                  <Button
                    styles={styles.criteriaButton}
                    type="button"
                    disabled={
                      !criteria ||
                      !criteria[index] ||
                      !criteria[index].compareBy ||
                      (CRITERIA_TAG_PROPERTY_OPTIONS[criteria[index].compareBy]
                        .showValues &&
                        !criteria[index].compareTo)
                    }
                    onClick={() => change(criteriaName + 'isEditing', false)}
                  >
                    <Translate value="done" />
                  </Button>
                  <Button
                    styles={[styles.flatButton, styles.criteriaButton]}
                    type="button"
                    onClick={() => fields.remove(index)}
                  >
                    <Translate value="cancel" />
                  </Button>
                </div>
              ) : (
                criteria && (
                  <Fragment key={index}>
                    <CriteriaCard
                      key={index}
                      criteria={criteria[index]}
                      onAndClick={() =>
                        fields.insert(index + 1, {
                          isEditing: true,
                          operation: CRITERIA_OPERATION_TYPES.AND
                        })
                      }
                      onEditClick={() =>
                        change(criteriaName + 'isEditing', true)
                      }
                      onDeleteClick={() => fields.remove(index)}
                      showAnd={!isEditing}
                    />
                    {(index === fields.length - 1 ||
                      criteria[index + 1].operation ===
                        CRITERIA_OPERATION_TYPES.OR) && (
                      <div className={css(styles.separator)} />
                    )}
                  </Fragment>
                )
              )
          )}
        {meta && meta.error && <li className="error">{meta.error}</li>}
        {!isEditing && (
          <Button
            styles={styles.addButton}
            type="button"
            onClick={() =>
              fields.push({
                isEditing: true,
                operation: CRITERIA_OPERATION_TYPES.OR
              })
            }
          >
            <Translate value="or" />
          </Button>
        )}
      </div>
    );
  }
}

export default AddCriteriaForm;



// WEBPACK FOOTER //
// ./src/components/forms/addtriggerform/addcriteriaform/AddCriteriaForm.js